export const domainList = [
    "hotmail.com",
    "gmail.com",
    "yahoo.com",
    "aol.com",
    "hotmail.co.uk",
    "msn.com",
    "yahoo.co.uk",
    "comcast.net",
    "live.com",
    "laposte.net",
    "googlemail.com",
    "btinternet.com",
    "sbcglobal.net",
    "ymail.com",
    "yahoo.com.br",
    "verizon.net",
    "live.co.uk",
    "att.net",
    "bellsouth.net",
    "gmx.net",
    "cox.net",
    "bigpond.com",
    "sky.com",
    "gmx.at",
    "ntlworld.com",
    "rocketmail.com",
    "yahoo.ca",
    "bluewin.ch",
    "yahoo.com.au",
    "aim.com",
    "abv.bg",
    "charter.net",
    "ig.com.br",
    "yahoo.gr",
    "optonline.net",
    "talktalk.net",
    "me.com",
    "bol.com.br",
    "tiscali.co.uk",
    "blueyonder.co.uk",
    "live.com.au",
    "uol.com.br",
    "mac.com",
    "earthlink.net",
    "inbox.lv",
    "163.com",
    "skynet.be",
    "optusnet.com.au",
    "live.be",
    "shaw.ca",
    "live.ca",
    "terra.com.br",
    "eircom.net",
    "juno.com",
    "mail.com",
    "qq.com",
    "gmx.ch",
    "telenet.be",
    "cegetel.net",
    "yahoo.ie",
    "telefonica.net",
    "windowslive.com",
    "seznam.cz",
    "wp.pl",
    "rogers.com",
    "aon.at",
    "yahoo.co.in",
    "embarqmail.com",
    "xtra.co.nz",
    "sympatico.ca",
    "ono.com",
    "bigpond.net.au",
    "windstream.net",
    "126.com",
    "videotron.ca",
    "yahoo.com.ar",
    "fsmail.net",
    "lightinthebox.com",
    "hotmail.be",
    "roadrunner.com",
    "gmx.com",
    "netzero.com",
    "telus.net",
    "yahoo.com.mx",
    "netzero.net",
    "hotmail.ca",
    "q.com",
    "ebuyclub.com",
    "virgin.net",
    "dbmail.com",
    "live.ie",
    "yahoo.com.sg",
    "netscape.net",
    "mchsi.com",
    "iinet.net.au",
    "azet.sk",
    "us.army.mil",
    "o2.pl",
    "walla.com",
    "freemail.hu"
];
